const SEMANTIC_LABELS = [
  [/\bDiagnostico primario:/g, 'Diagnóstico primario:'],
  [/\bDiagnostico secundario:/g, 'Diagnóstico secundario:'],
  [/\bDiagnostico presuntivo:/g, 'Diagnóstico presuntivo:'],
  [/\bResultado diagnostico:/g, 'Resultado diagnóstico:'],
  [/\bSituacion animal/g, 'Situación animal'],
  [/\bsituacion:/g, 'situación:'],
  [/\bGrupo zootecnico:/g, 'Grupo zootécnico:'],
  [/\bCategoria animal:/g, 'Categoría animal:'],
  [/\bcategoria:/g, 'categoría:'],
  [/\bBiologia molecular:/g, 'Biología molecular:'],
  [/\bnumero:/g, 'número:'],
  [/\bpatogenos blanco:/g, 'patógenos blanco:'],
];

export const formatSemanticText = (value = '') =>
  SEMANTIC_LABELS.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), String(value));
